import TagsService from "external-services/tags-service";

// requiring html templates so that hot reloading works
const template = require('./newBookingTags.html');
const NS = 'NewBookingTags';

export default function NewBookingTags() {
  return {
    restrict: 'E',
    replace: true,
    controllerAs: 'vm',
    template,
    scope: {
      tags: '=',
      allTags: '=',
      customer: '='
    },
    controller
  }
}

// just exported for unit tests
export function controller($scope, hardCodedTags) {
  "ngInject";


  var vm = this;

  vm.sharedTagHeading = TagsService.sharedTagHeading;
  vm.diaryTagHeading= TagsService.diaryTagHeading;
  vm.addTag = addTag;
  vm.removeTag = removeTag;
  vm.querySearch = querySearch;

  vm.$onInit = function () {
    if (!$scope.allTags) {
      TagsService.getTags().then(function (tags) {
        vm.initTags(tags);
      });
    } else {
       vm.initTags($scope.allTags);
    }
  }

  vm.initTags = function(tags){
    // we never need to show the delivery tag for new bookings. It is only ever needed on booking options when in Takeaway mode
    tags = tags.filter(t => t._id !== hardCodedTags.DELIVERY_TAG_ID);
    vm.allTags = tags.map(function(tag) {
      let tagType = {name: tag.tagtype.name, _id: tag.tagtype._id}
      return {colour: tag.colour, editable: false, icon: tag.icon, name: tag.name, noneditable: false, online: tag.online, order: 0, permanent: tag.permanent, tagtype: tagType, type: tag.type, _id: tag._id}
    });
    vm.sharedTags = vm.allTags.filter(t=> t.tagtype._id === hardCodedTags.SHARED_TAG_TYPE);
    vm.diaryTags = vm.allTags.filter(t=> t.tagtype._id !== hardCodedTags.SHARED_TAG_TYPE);
  }
  /**
   * Add a tag to the booking
   * @param  {Object} tag The tag to remove
   */
  function addTag(tag) {
    if (tag && tag !== undefined && (tag.tagtype || tag.tagType)) {
      // create tag array on booking if it does not exist
      if (!$scope.tags) {
        $scope.tags = [];
      }
      var index = $scope.tags.map(function (e) {
        return e._id;
      }).indexOf(tag._id);

      // make sure the tag is not already in the array
      if (index === -1 && tag) {
        $scope.tags.push(tag);
        $scope.$emit('tags-updated');
        vm.searchText = '';
      }

      $scope.tags = $scope.tags.filter((tag, index, tags) =>  tags.findIndex(currentTag => currentTag._id === tag._id) === index);
    }
  }


  /** Remove a tag from the booking
   * @param  {Object} tagToRemove The tag to remove
   */
  function removeTag(tagToRemove) {
    var index = $scope.tags.map(function (e) {
      return e._id;
    }).indexOf(tagToRemove._id);
    if (index > -1 && tagToRemove) {
      $scope.tags.splice(index, 1);
      $scope.$emit('tags-updated');
    }
  }

  function querySearch(query) {
    return TagsService.searchTags(query, vm.allTags);
  }
}


